import { render, staticRenderFns } from "./ImageLoading.vue?vue&type=template&id=56e8af2c"
import script from "./ImageLoading.vue?vue&type=script&lang=js"
export * from "./ImageLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports